import { useQuery } from '@tanstack/react-query';
import { calendarGetICSEvents, calendarGetICSSubscription } from '@uplift/api';
import { BaseQueryOpts } from '../baseTypes';


export const useICSSubscriptionQuery = (providerId: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'icsSubscription', providerId ],
    queryFn: async () => {
      const response = await calendarGetICSSubscription();

      return response.data;
    },
    ...opts
  });
};


export const useICSSubscriptionEventsQuery = (providerId: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'icsSubscription', providerId, 'events' ],
    queryFn: async () => {
      try {
        const response = await calendarGetICSEvents();

        return response.data;
      } catch (err) {
        return null;
      }
    },
    staleTime: Infinity,
    ...opts
  });
};
